import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
const ProtectedRoute = () => {
  const isLoggedIn = useSelector((state) => state.auth.token);
  return isLoggedIn ? <Outlet /> : <Navigate replace to={"/login"} />;
};
export default ProtectedRoute;
